import { ReactElement } from "react";

import styles from "./footerButtons.module.css";

import TermsAndConditions from "../termsAndConditions/TermsAndConditions";

const FooterButtons = ({
  children,
}: {
  children: React.ReactNode;
}): ReactElement => {
  return (
    <div className={styles.container}>
      <TermsAndConditions />
      <div className={styles.buttonContainer}>{children}</div>
    </div>
  );
};

export default FooterButtons;
